import { z } from "zod";

/**
 * Shared validation refinement for address details.
 * Validates address fields based on addressMode (lookup vs manual).
 *
 * This validation is used by both the main form schema and Storybook stories
 * to ensure consistency across the application.
 *
 * @param data - The form data containing address fields
 * @param ctx - Zod refinement context for adding validation issues
 */
export function validateAddressDetails(
  data: {
    addressMode: "lookup" | "manual";
    finalAddress?: string;
    addressLine1?: string;
    postTown?: string;
  },
  ctx: z.RefinementCtx,
): void {
  // Conditional validation based on addressMode
  if (data.addressMode === "lookup") {
    if (!data.finalAddress || data.finalAddress.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please select an address",
        path: ["finalAddress"],
      });
    }
  } else {
    // Manual address mode
    if (!data.addressLine1 || data.addressLine1.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please enter address line 1",
        path: ["addressLine1"],
      });
    }
    if (!data.postTown || data.postTown.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please enter a town/city",
        path: ["postTown"],
      });
    }
  }
}
